<template>

    <div class="p-grid nested-grid p-jc-center controls">
        <div class="p-col-fixed">
          <Control v-model="setpoints.temperature" icon="icon-air_temp" :isTemperature="true" 
            :min="getLimits(recipe.phases[currentSlide].type).cellSetTempMin" 
            :max="getLimits(recipe.phases[currentSlide].type).cellSetTempMax" 
            @update:modelValue="(temperature) => { setpoints.temperature = temperature; }" />
        </div>
        <div v-if="isCoreVisible(recipe.phases[currentSlide])" class="p-col-fixed">
          <Control v-model="setpoints.core" icon="icon-core_temp" :isTemperature="true" 
            :min="getLimits(recipe.phases[currentSlide].type).coreProbeSetTempMin" 
            :max="getLimits(recipe.phases[currentSlide].type).coreProbeSetTempMax" 
            @update:modelValue="(core) => { setpoints.core = core; }" />
        </div>
        <div v-if="isDurationVisible(recipe.phases[currentSlide])" class="p-col-fixed">
          <Control v-model="setpoints.time" icon="icon-time" :isTime="true" 
            :min="getLimits(recipe.phases[currentSlide].type).phaseDurationSetMin" 
            :max="getLimits(recipe.phases[currentSlide].type).phaseDurationSetMax" 
            @update:modelValue="(time) => { setpoints.time = time; }"/>
        </div>
        <div class="p-col-fixed">
          <Control v-model="setpoints.fan" icon="icon-fan" 
            :min="getLimits(recipe.phases[currentSlide].type).evapFanSetSpeedMin" 
            :max="getLimits(recipe.phases[currentSlide].type).evapFanSetSpeedMax" 
            @update:modelValue="(fan) => { setpoints.fan = fan; }"/>
        </div>
    </div>

</template>

<script>
import commands from "../../../../public/json/commands_mf.json";
import Control from '../../appliances/Control.vue';
import { mapGetters } from 'vuex';

export default {
  emits: ['update:setpoints'],
  components: {
      Control,
    },
    props: {
      recipe: Object,
      currentSlide: Number,
    },
    data() {
        return {
          commands: commands,
          setpoints: {},
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
          // storedRecipe: 'library/recipe'
        }),
        appliance: function() {
            return this.serialNumber ? this.$store.getters['appliances/appliance'](this.serialNumber) : null;
        },
        command() {
          return this.commands.functions[this.recipe.function];
        },
    },
    created() {
    },
    mounted() {
      this.updateSetpoints();
    },
    watch: {
      'setpoints.temperature' : 'setpointsChanged',
      'setpoints.core' : 'setpointsChanged',
      'setpoints.time' : 'setpointsChanged',
      'setpoints.fan' : 'setpointsChanged'
    },
    methods: {
      setpointsChanged() {
        this.$emit("update:setpoints", this.setpoints);
      },
      isCoreVisible(phase) {
        let p = this.command.phases[phase.type];
        return (p && p.coreProbeSetTempMin != null && p.coreProbeSetTempMax!=null);
      },
      isDurationVisible(phase) {
        let p = this.command.phases[phase.type];
        return (p && p.phaseDurationSetMin != null && p.phaseDurationSetMax!=null);
      },
      getLimits(phaseType) {
        try {
          let p = this.command.phases[String(phaseType)];
          if(p) {
            let lim = this.$functions.clone(p);
            if(lim.cellSetTempMin) {
              lim.cellSetTempMin*=10;
            }
            if(lim.cellSetTempMax) {
              lim.cellSetTempMax*=10;
            }
            if(lim.coreProbeSetTempMin) {
              lim.coreProbeSetTempMin*=10;
            }
            if(lim.coreProbeSetTempMax) {
              lim.coreProbeSetTempMax*=10;
            }
            return lim;
          }
        } catch(err) {
          console.warn("Error parsing commands " + err);
        }
        return {
            name: null,
            cellSetTempMin: null,
            cellSetTempMax: null,
            coreProbeSetTempMin: null,
            coreProbeSetTempMax: null,
            setLevelHumidityMin: null,
            setLevelHumidityMax: null,
            evapFanSetSpeedMin: null,
            evapFanSetSpeedMax: null,
            phaseDurationSetMin: null,
            phaseDurationSetMax: null
          };
      },
      updateSetpoints() {
        this.setpoints = {};
        let phase = this.recipe.phases[this.currentSlide];
        let phaseType = phase.type;
        this.setpoints = {
          temperature: phase.set_temp_room*10,
          core: phase.set_temp_probe*10,
          humidity: phase.set_humidity,
          time: phase.set_duration/60,
          fan: phase.set_ventilation,
          phase: this.currentSlide + 1
        };

        if(this.getLimits(phaseType).cellSetTempMin != null && this.setpoints.temperature < this.getLimits(phaseType).cellSetTempMin) {
          this.setpoints.temperature = this.getLimits(phaseType).cellSetTempMin;
        }
        if(this.getLimits(phaseType).cellSetTempMax != null && this.setpoints.temperature > this.getLimits(phaseType).cellSetTempMax) {
          this.setpoints.temperature = this.getLimits(phaseType).cellSetTempMax;
        }

        if(this.getLimits(phaseType).coreProbeSetTempMin != null && this.setpoints.core < this.getLimits(phaseType).coreProbeSetTempMin) {
          this.setpoints.core = this.getLimits(phaseType).coreProbeSetTempMin;
        }
        if(this.getLimits(phaseType).coreProbeSetTempMax != null && this.setpoints.core > this.getLimits(phaseType).coreProbeSetTempMax) {
          this.setpoints.core = this.getLimits(phaseType).coreProbeSetTempMax;
        }

        if(this.getLimits(phaseType).setLevelHumidityMin != null && this.setpoints.humidity < this.getLimits(phaseType).setLevelHumidityMin) {
          this.setpoints.humidity = this.getLimits(phaseType).setLevelHumidityMin;
        }
        if(this.getLimits(phaseType).setLevelHumidityMax != null && this.setpoints.humidity > this.getLimits(phaseType).setLevelHumidityMax) {
          this.setpoints.humidity = this.getLimits(phaseType).setLevelHumidityMax;
        }

        if(this.getLimits(phaseType).phaseDurationSetMin != null && this.setpoints.time < this.getLimits(phaseType).phaseDurationSetMin) {
          this.setpoints.time = this.getLimits(phaseType).phaseDurationSetMin;
        }
        if(this.getLimits(phaseType).phaseDurationSetMax != null && this.setpoints.time > this.getLimits(phaseType).phaseDurationSetMax) {
          this.setpoints.time = this.getLimits(phaseType).phaseDurationSetMax;
        }

        if(this.getLimits(phaseType).evapFanSetSpeedMin != null && this.setpoints.fan < this.getLimits(phaseType).evapFanSetSpeedMin) {
          this.setpoints.fan = this.getLimits(phaseType).evapFanSetSpeedMin;
        }
        if(this.getLimits(phaseType).evapFanSetSpeedMax != null && this.setpoints.fan > this.getLimits(phaseType).evapFanSetSpeedMax) {
          this.setpoints.fan = this.getLimits(phaseType).evapFanSetSpeedMax;
        }

      },
      
    },

}
</script>

<style scoped>
</style>